import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import { type StripeCheckoutSessionParams } from './TuitionAndRegistration.types';

type StripeCheckoutSessionResponse = {
    session?: {
        url?: string;
    };
};

export const stripeCheckoutSessionApi = createApi('StripeCheckoutSession', {
    ...getBackRoyalApiBaseConfig('StripeCheckoutSession'),
    endpoints: builder => ({
        createCheckoutSession: builder.mutation<StripeCheckoutSessionResponse, StripeCheckoutSessionParams>({
            query: params => ({
                url: 'stripe_checkout_sessions',
                method: 'POST',
                body: params,
            }),
        }),
    }),
});
